// import React from 'react';
// import useLangTranslation from '../../customHooks/languageProvider';
// import { Link } from 'react-router-dom';

// const AuthSignUp = () => {
//     const { getLangTranslation } = useLangTranslation();
//     return (
//         <p className="text-center my-6 fw-semibold">
//             {getLangTranslation("LOGIN_CHILD_DON'T_HAVE_AN_ACC", "Don't have an account?")}<Link to='/auth/create-an-account' className="ms-1">{getLangTranslation('LOGIN_CHILD_SIGN_UP', 'Sign Up')}</Link>
//         </p>
//     )
// }

// export default AuthSignUp
// import React from 'react';
// import useLangTranslation from '../../customHooks/languageProvider';

// const AuthSignUp = () => {
//   const { getLangTranslation } = useLangTranslation();

//   return (
//     <p className="text-center my-6 fw-semibold">
//       {getLangTranslation(
//         'WEB_SIGNUP_DISABLED_MSG',
//         'Sign up via the web is temporarily unavailable. Please download the app to create an account, then log in here.'
//       )}
//     </p>
//   );
// };

// export default AuthSignUp;
"use client";

import { useEffect, useState } from "react";

const AuthSignUp = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <p className="text-center my-6 fw-semibold" style={{ color: "#e57373" }}>
      Web sign-up is temporarily unavailable.
      <br />
      Please download the app to create an account, then log in to the web portal.
      <br />
      <span>
        <span style={{ color: "#000" }}>Download the app: </span>
        <a
          href="https://play.google.com/store/search?q=kidoprotect&c=apps&hl=en"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1a73e8", textDecoration: "underline" }}
        >
          https://play.google.com/store/search?q=kidoprotect&c=apps&hl=en
        </a>
      </span>
    </p>
  );
};

export default AuthSignUp;
